/** Salt okunur salonda (pasif ya da salonsuz hesap) yazma düğmelerinin `title`'ı. */
export const READ_ONLY_TITLE = 'Salon pasif — yalnız görüntüleme';
